<template>
	<div>
		<app-header></app-header>
		<div v-show="isShowUploadDiv">
            <v-container fluid grid-list-xl mt-7>
                <v-layout row wrap justify-center>
                    <v-flex xs12 md10 lg6 class="col-height-auto">
                        <div class="font-2x fw-bold">{{$t("uploadMaterial.selfie")}}</div>
                        <div class="font-lg mt-3">{{userRequest.regEmail + ','}}{{$t("uploadMaterial.attachMessage")}}</div>
                            <v-form class="font-lg mt-3">
                                <Upload type="drag"
                                enctype="multipart/form-data"
                                        action=""
                                        name="upfile"
                                        :before-upload="beforeUpload"
                                        :show-upload-list=false>
                                        <Icon type="ios-cloud-upload" size="50" class="primary--text"></Icon>
                                        <p v-if="file !== null">{{$t("uploadMaterial.uploadFile")}}: {{ file.name }}</p>
                                        <p v-else>{{$t("uploadMaterial.uploadHint")}}</p>
                                </Upload>
                                <v-btn outline class="primary--text mt-3" @click="clearFile">
                                    {{$t("common.clear")}}
                                </v-btn>
                                <v-btn outline class="primary--text mt-3" :loading="uploadLoading" :disabled="file == null" @click="uploadFile">
                                    {{$t("uploadMaterial.upload")}}
                                    <v-icon right dark>cloud_upload</v-icon>
                                </v-btn>
                            </v-form>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <div v-show="!isShowUploadDiv">
            <app-link-invalid></app-link-invalid>
        </div>
	</div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                userRequest: {},                //用户请求对象
                file: null,                     //上传的文件
                uploadLoading: false,           //上传加载中
                isShowUploadDiv: true,         //是否显示上传的div
            }
        },
        created(){
            
        },
        mounted(){
            this.verifyLink();
        },
        watch:{
            '$router':'verifyLink'
        },
        methods: {
            //验证链接是否有效
            verifyLink(){
                let currentUrl = window.location.href;
                let requestId = currentUrl.substring(currentUrl.lastIndexOf("/") + 1, currentUrl.length);
                let verifyUrl = config.baseUrl + 'request/open/verifyRequest?requestId=' + requestId;
                this.$http.get(verifyUrl).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        //正常访问
                        this.userRequest = data.result;
                        this.isShowUploadDiv = true;
                    }else {
                        //无效
                        this.userRequest = {};
                        this.isShowUploadDiv = false;
                    }
                });
            },
            //上传之前的函数
            beforeUpload(file){
                let fileName = file.name;
                let suffix = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length).toLowerCase();
                if (suffix == "jpg" || suffix == "jpeg" || suffix == "png") {
                    //格式正确,判断大小在1M以内
                    let fileSize = file.size;
                    if (fileSize > 1024 * 1024) {
                        //文件太大
                        this.file = null;
                        this.$Message.error({
                            content: this.$t('uploadMaterial.message.tooLarge'),
                            duration:5,
                            closable: true
                        });
                    } else {
                        this.file = file;
                    }
                } else {
                    this.file = null;
                    //格式错误
                    this.$Message.error({
                        content: this.$t('uploadMaterial.message.formatIncorrect'),
                        duration:5,
                        closable: true
                    });
                }
                //return false表示不自动上传
                return false;
            },
            //清除文件
            clearFile(){
                this.file = null;
            },
            //上传文件
            uploadFile(){
                this.uploadLoading = true;
                let url = config.baseUrl + "request/open/uploadFile/" + this.userRequest.userRequestId;
                // let url = config.baseUrl + "userDetail/open/uploadToFTPServer?userId=1234567890";
                var fileData = new FormData();
                fileData.append('upfile', this.file);//upfile是键，file是值，就是要传的文件
                this.$http.post(url, fileData).then(successData => {
                    this.uploadLoading = false;
                    this.clearFile();
                    let data = successData.data;
                    if (data.resCode == 0) {
                        //上传成功,发送通知邮件，显示通知
                        this.sendNoticeEmail();
                        this.$Notice.success({
                            title: this.$t('uploadMaterial.message.uploadSuccessTitle'),
                            duration: 10,
                            desc: this.$t('uploadMaterial.message.uploadSuccessDesc')
                        });
                        this.$router.push({name: "home"});
                    }else{
                        this.$Message.error(this.$t("common.fail"));
                    }
                }, error => {
                    this.$Message.error(this.$t("common.fail"));
                    this.uploadLoading = false;
                });
            },
            //发送通知邮件
            sendNoticeEmail(){
                let url = config.baseUrl + "sendEmail/open/sendUploadMaterialNoticeEmail?userRequestId=" + this.userRequest.userRequestId;
                this.$http.get(url).then(response => {
                    
                });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// UploadMaterial.vue?b2d01330